import React from 'react';
import PropTypes from 'prop-types';
import {t} from '../../Translations'
import Label from './Label';
import Select from './Select';

const ChoiceRow = ({index,classLabel, label, value, data, loading, onChange,className}) => (

  <div key={index} className="row my-4 my-md-2">
      <div className="col-12 col-md-6 step1-label">
        <Label className={classLabel}>{label}</Label>
      </div>

      <div className="col-12 col-md-6">
          <Select
              value={value}
              className={className}
              placeholder={loading ? t('Step1_rims_loading') : t('Step1_select')}
              data={data}
              disabled={(!data || data.length === 0 )}
              onChange={onChange}
          />
      </div>
  </div>
);

ChoiceRow.propTypes = {
  index: PropTypes.number,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  classLabel: PropTypes.string,
  //data: choiceDataPropTypes.isRequired,
  loading: PropTypes.bool,
  onChange: PropTypes.func
};

ChoiceRow.defaultProps = {
  index: 0,
  value: undefined,
  loading: false,
  classLabel:""
};

export default ChoiceRow;


// WEBPACK FOOTER //
// ./src/components/widgets/ChoiceRow.js